import React from 'react'
import PropTypes from 'prop-types'
import Path from '@leverege/path'
import ObjectUtil from '@leverege/object-util'

import { Dialog } from '@leverege/ui-elements'
import { UpdaterSelector, UpdaterFactory } from '~/editors/updaters'

/**
 * This is an editor to allow an Updater to be selected for an attribute. When
 * the apply button is pressed, it will be sent to the call back for distribution
 * to the server
 **/
export default class SimUpdaterEditor extends React.Component {
  
  static propTypes = {
    updater : PropTypes.object,
    attribute : PropTypes.object,
    onApplyUpdater : PropTypes.func
  }

  constructor( props ) {
    super( props )
    this.state = { updater : this.props.updater, advanced : false }
    this.onSetUpdater = this.onSetUpdater.bind( this )
    this.onUpdaterChange = this.onUpdaterChange.bind( this )
    this.onUpdaterSelected = this.onUpdaterSelected.bind( this )
    this.shouldRender = true
  }

  onUpdaterSelected( updater ) {
    this.shouldRender = true
    this.setState( { updater } )
  }

  onUpdaterChange( evt ) {
    // evt: { target: this.props.attribute, path: path, value: value }
    const clone = ObjectUtil.copy( this.state.updater )
    Path( evt.path ).set( clone, evt.value )
    this.setState( { updater : clone } )
  }

  onSetUpdater() {
    this.props.onSetUpdater( { updater : ObjectUtil.copy( this.state.updater ), attribute : this.props.attribute } )
  }

  shouldComponentUpdate( nextProps, nextState ) {
    const { show } = this.props
    const { show : nShow } = nextProps

    const shouldRender = this.shouldRender || show !== nShow

    if ( shouldRender ) {
      this.shouldRender = false
      return true;
    }

    return false;
  }

  render() {
    const { attribute, show, title, onHideFullEditor } = this.props

    return (
      <Dialog.Question
        variant="dialogMedium"
        show={show}
        title={title}
        okay="Apply"
        onOkay={this.onSetUpdater}
        onCancel={onHideFullEditor}
        onClose={onHideFullEditor}>
        <label>Select Updater</label>
        <UpdaterSelector hint="" fontIcon="fa fa-chevron-down" attribute={attribute} onSelect={this.onUpdaterSelected} updater={this.state.updater} /> 
        {UpdaterFactory.createEditor( this.state.updater, { onChange : this.onUpdaterChange } ) ||
          <div style={{ height : '100px' }} />}
      </Dialog.Question>
    )
  }
}
